import React, { useState, useEffect, useRef } from 'react'
import { Share2, Eye, EyeOff, Inbox } from "lucide-react";

import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import CurFt from '../../components/CurFt';
function Filters(_props) {
    // const [openEye, setOpenEye] = useState(false);
    const setOpenEye = _props.setOpenEye;
    const openEye = _props.openEye;
    const allMins = _props.FiltPrice.map(item => item.Minpr);
    const allMaxs = _props.FiltPrice.map(item => item.Maxpr);

    const MinPriceRange = Math.min(...allMins);
    const MaxPriceRange = Math.max(...allMaxs);

    const [minVal, setMinVal] = useState(MinPriceRange);
    const [maxVal, setMaxVal] = useState(MaxPriceRange);

    useEffect(() => {

        if (minVal !== undefined && maxVal !== undefined) {
            _props.priceRangeFilter([minVal, maxVal])
        }
    }, [minVal, maxVal]);

    const departTimes = [
        { id: "early", label: "Before", time: "00:00-10:00", timelabel: "10 AM", icon: "🌅" },
        { id: "morning", label: "", time: "10:00-15:00", timelabel: "10 AM-3 PM", icon: "☀️" },
        { id: "afternoon", label: "", time: "15:00-20:00", timelabel: "3 PM-8 PM", icon: "🌇" },
        { id: "night", label: "After", time: "20:00-24:00", timelabel: "8 PM", icon: "🌙" },
    ];
    const arrivalTimes = [
        { id: "Arearly", label: "Before", time: "00:00-10:00", timelabel: "10 AM", icon: "🌅" },
        { id: "Armorning", label: "", time: "10:00-15:00", timelabel: "10 AM-3 PM", icon: "☀️" },
        { id: "Arafternoon", label: "", time: "15:00-20:00", timelabel: "3 PM-8 PM", icon: "🌇" },
        { id: "Arnight", label: "After", time: "20:00-24:00", timelabel: "8 PM", icon: "🌙" },
    ];
    const departTimesInbound = [
        { id: "earlyInbound", label: "Before", time: "00:00-10:00", timelabel: "10 AM", icon: "☀️" },
        { id: "morningInbound", label: "", time: "10:00-15:00", timelabel: "10 AM-3 PM", icon: "☀️" },
        { id: "afternoonInbound", label: "", time: "15:00-20:00", timelabel: "3 PM-8 PM", icon: "🌇" },
        { id: "nightInbound", label: "After", time: "20:00-24:00", timelabel: "8 PM", icon: "🌙" },
    ];
    const arrivalTimesInbound = [
        { id: "ArearlyInbound", label: "Before", time: "00:00-10:00", timelabel: "10 AM", icon: "☀️" },
        { id: "ArmorningInbound", label: "", time: "10:00-15:00", timelabel: "10 AM-3 PM", icon: "☀️" },
        { id: "ArafternoonInbound", label: "", time: "15:00-20:00", timelabel: "3 PM-8 PM", icon: "🌇" },
        { id: "ArnightInbound", label: "After", time: "20:00-24:00", timelabel: "8 PM", icon: "🌙" },
    ];


    return (

        <aside className="w-full md:w-1/4 space-y-4 md:sticky md:top-4 self-start max-h-[calc(100vh-2rem)] overflow-y-auto">
            {_props.FormData && _props.FormData.routeType === '2' && _props.FormData.interNationalSearch === '0' &&
                <>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
                        <div className="flex items-center">
                            <input type="checkbox" id="specialReturn" checked={_props.showSpecialReturn} onChange={(e) => _props.setShowSpecialReturn(e.target.checked)} className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" />
                            <label htmlFor="specialReturn" className="ml-2 text-sm font-medium text-gray-800 cursor-pointer" >
                                Special Return
                            </label>
                        </div>
                    </div>
                    {_props.showSpecialReturn && <div className="bg-white rounded-lg shadow p-4">
                        <div className="space-y-2">
                            <div className="rounded-lg">
                                <h3 className="font-semibold text-gray-800 mb-3">
                                    Special Return Airline(s)
                                </h3>

                                {_props.FiltAirlineSSP && _props.FiltAirlineSSP.length > 0 && _props.FiltAirlineSSP.map((item, x) => (
                                    <label className="flex items-center gap-2" key={x}>
                                        <input type="checkbox" onChange={(e) => _props.handleAirlineNameSSP(e)} value={item.AirlineName} className="form-checkbox h-4 w-4" />
                                        <img src={`${item.logo}`} alt={item.logo} className="rounded-md w-5 h-5" />
                                        {item.AirlineName}
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>}
                </>
            }
            <div className="bg-white rounded-lg shadow p-4">
                <div className="flex items-center justify-between gap-4 border-b pb-2">
                    <button className="flex items-center gap-2"
                        onClick={() => _props.setshowProposalPopup(!_props.showProposalPopup)}
                    >
                        <Share2 size={18} />
                        <span>Share</span>
                    </button>
                    <button
                        onClick={() => _props.setOpenEye(!openEye)}
                        className="flex items-center gap-2 "
                    >
                        {openEye ? <EyeOff size={18} /> : <Eye size={18} />}
                        <span>{openEye ? "Hide Incv/Net" : "Show Incv/Net"}</span>
                    </button>
                </div>
                <h3 className="font-semibold mb-3">Price</h3>
                <div className="mb-2">
                    <RangeSlider value={_props.PriceRange} min={MinPriceRange} max={MaxPriceRange} onInput={_props.priceRangeFilter} onClick={_props.priceRangeFilter} id="range-slider-yellow" onChange={_props.priceRangeFilter} />
                </div>

                {_props?.data && _props?.data?.length > 0 && <div className="flex justify-between items-center">
                    <>
                        <div>
                            {_props?.data[0]?.FareList[0]?.Currency == 'INR' ? <CurFt currency={_props?.data[0]?.FareList[0]?.Currency || 'INR'} price={Math.ceil(_props.PriceRange[0])} /> : <CurFt currency={_props?.data[0]?.FareList[0]?.Currency || 'INR'} price={_props.PriceRange[0]} />}
                        </div>

                        <div>
                            {_props?.data[0]?.FareList[0]?.Currency == 'INR' ? <CurFt currency={_props?.data[0]?.FareList[0]?.Currency || 'INR'} price={Math.ceil(_props.PriceRange[1])} /> : <CurFt currency={_props?.data[0]?.FareList[0]?.Currency || 'INR'} price={_props.PriceRange[1]} />}
                        </div>
                    </>
                </div>}

            </div>

            <div className="bg-white rounded-lg shadow p-4">
                <div className="space-y-4 mb-2 mt-2">
                    {/* {_props.FiltStop && _props.FiltStop.length > 0 && _props.FiltStop.map((stops, index) => (
                        <div key={index} className="border border-gray-200 rounded-lg p-3">
                            <h3 className="font-semibold text-gray-800 mb-3">No of Stop(s) -
                                {index === 0 ? "Outbound" : "Inbound"}
                            </h3>

                            <div className="space-y-2">
                                {stops.map((item, subIndex) => (
                                    <label key={subIndex} className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => index === 0 ? _props.handleChangeStops(e) : _props.handleChangeStopsInbound(e)}
                                            value={item}
                                            className="form-checkbox h-4 w-4 text-blue-600 border-gray-300 rounded"
                                        />
                                        <span className="text-gray-700">
                                            {item === "0 Stop" ? "Non-Stop" : item}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    ))} */}
                    {_props.FiltStop && _props.FiltStop.length > 0 && _props.FiltStop.map((stops, index) => {

                        if (
                            index >= 1 &&
                            _props.FormData &&
                            _props.FormData.routeType === '2' &&
                            _props.FormData.interNationalSearch === '1'
                        ) {
                            return null;
                        }

                        return (
                            <div key={index} className=" rounded-lg">
                                <h3 className="font-semibold text-gray-800 mb-3">
                                    {index === 0 ? "Onward" : "Return"} Stop(s)
                                </h3>

                                <div className="space-y-2">
                                    {stops.map((item, subIndex) => (
                                        <label key={subIndex} className="flex items-center gap-2">
                                            <input type="checkbox" onChange={(e) => index === 0 ? _props.handleChangeStops(e) : _props.handleChangeStopsInbound(e)}
                                                value={item} className="form-checkbox h-4 w-4 text-blue-600 border-gray-300 rounded" />
                                            <span className="text-gray-700">
                                                {item === "0 Stop" ? "Non-Stop" : item}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        );
                    })}

                </div>
            </div>
            <div className="bg-white rounded-lg shadow p-4">
                <div className="space-y-2">
                    {_props.FiltAirline && _props.FiltAirline.length > 0 && _props.FiltAirline.map((airlines, index) => {
                        if (
                            index >= 1 &&
                            _props.FormData &&
                            _props.FormData.routeType === '2' &&
                            _props.FormData.interNationalSearch === '1'
                        ) {
                            return null;
                        }

                        return (
                            <div key={index} className="rounded-lg">
                                <h3 className="font-semibold text-gray-800 mb-3">
                                    {index === 0 ? "Onward" : "Return"} Airline(s)
                                </h3>

                                {airlines && airlines.length > 0 && airlines.map((item, x) => (
                                    <label className="flex items-center gap-2" key={x}>
                                        <input
                                            type="checkbox"
                                            onChange={(e) =>
                                                index === 0
                                                    ? _props.handleChangeAirlines(e)
                                                    : _props.handleChangeAirlinesInbound(e)
                                            }
                                            value={item.split('-')[1]}
                                            className="form-checkbox h-4 w-4"
                                        />
                                        <img
                                            src={`/AirlineLogo/${item.split('-')[0]}.png`}
                                            alt={item.split('-')[1]}
                                            className="rounded-md w-5 h-5"
                                        />
                                        {item}
                                    </label>
                                ))}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="bg-white rounded-lg shadow p-4">
                <div className="space-y-2">
                    {_props.FormData &&
                        <div className="rounded-lg">
                            <h3 className="font-semibold text-gray-800 mb-3">
                                Onward Fare Policy
                            </h3>
                            <label className="flex items-center gap-2">
                                <input type="radio" name="refund" id='allradio' onChange={_props.handleChangeFarepol} value={"NA"} autoComplete="off" />
                                All
                            </label>
                            <label className="flex items-center gap-2">
                                <input type="radio" name="refund" onChange={_props.handleChangeFarepol} value={0} autoComplete="off" />
                                Non-Refundable
                            </label>
                            <label className="flex items-center gap-2">
                                <input type="radio" name="refund" onChange={_props.handleChangeFarepol} value={1} autoComplete="off" />
                                Refundable
                            </label>
                            <label className="flex items-center gap-2">
                                <input type="radio" name="refund" onChange={_props.handleChangeFarepol} value={2} autoComplete="off" />
                                Partial-Refundable
                            </label>
                        </div>
                    }
                </div>
            </div>

            {_props.FormData &&
                <div className="bg-white rounded-lg shadow p-4">
                    <div className="space-y-2">
                        <div className="rounded-lg">
                            <h3 className="font-semibold text-gray-800 mb-3">
                                Onward Fare Class
                            </h3>

                            <label className="flex items-center gap-2" >
                                <input type="radio" name="refund" id='allcheckbox' onChange={_props.handleFareClassOutbound} value={"NA"} autoComplete="off" />
                                All
                            </label>
                            {_props.FiltFareClassOutbound && _props.FiltFareClassOutbound.map((item, index) =>
                                <label className="flex items-center gap-2" key={index}>
                                    <input type="radio" name="refund" id='allcheckbox' onChange={_props.handleFareClassOutbound} value={item} autoComplete="off" />
                                    {item}
                                </label>
                            )}
                        </div>
                    </div>
                </div>
            }
            {/* {_props.FormData && _props.FormData.routeType == '2' &&
                <div className="bg-white rounded-lg shadow p-4">
                    <div className="space-y-2">
                        <div className="rounded-lg">
                            <h3 className="font-semibold text-gray-800 mb-3">
                                Return Fare Class
                            </h3>
                            <label className="flex items-center gap-2" >
                                <input type="radio" name="FareReturn" id='allcheckboxReturn' onChange={_props.handleFareClassInbound} value={"NA"} autoComplete="off" />
                                All
                            </label>
                            {_props.FiltFareClassInbound && _props.FiltFareClassInbound.map((item, index) =>
                                <label className="flex items-center gap-2" key={index}>
                                    <input type="radio" name="FareReturn" id='allcheckboxReturn' onChange={_props.handleFareClassInbound} value={item} autoComplete="off" />
                                    {item}
                                </label>
                            )}
                        </div>
                    </div>
                </div>
            } */}

            <div className="bg-white rounded-lg shadow p-4">
                <h3 className="font-semibold text-gray-800 mb-3">
                    Onward Departure Time
                </h3>

                <div className="grid grid-cols-2 sm:grid-cols-4 ">
                    {departTimes.map((item) => (
                        <label
                            key={item.id}
                            className={`flex flex-col items-center p-1 border cursor-pointer rounded-lg transition-all duration-200 ${_props.selectedDeparture.includes(item.time) ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-gray-400"}`}
                        >
                            <input
                                type="checkbox"
                                value={item.time}
                                id={item.id}
                                onChange={_props.handleChangeDeparture}
                                className="hidden"
                            />
                            <div className="text-md mb-2">{item.icon}</div>
                            <div className="font-semibold text-sm text-gray-700">{item.label}</div>
                            <div className="text-xs text-gray-500">{item.timelabel}</div>
                        </label>
                    ))}
                </div>
                <h3 className="font-semibold text-gray-800 mb-3">
                    Onward Arrival Time
                </h3>
                <div className="grid grid-cols-2 sm:grid-cols-4">
                    {arrivalTimes.map((item) => (
                        <label
                            key={item.id}
                            className={`flex flex-col items-center p-1 border cursor-pointer rounded-lg transition-all duration-200 ${_props.selectedArrival.includes(item.time) ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-gray-400"}`}
                        >
                            <input
                                type="checkbox"
                                value={item.time}
                                id={item.id}
                                onChange={_props.handleChangeArrival}
                                className="hidden"
                            />
                            <div className="text-md mb-2">{item.icon}</div>
                            <div className="font-semibold text-sm text-gray-700">{item.label}</div>
                            <div className="text-xs text-gray-500">{item.timelabel}</div>
                        </label>
                    ))}
                </div>
            </div>

            {_props.FormData && _props.FormData.routeType == '2' && _props.FormData.interNationalSearch == '0' &&
                <>
                    <div className="bg-white rounded-lg shadow p-4" style={{ marginBottom: '55px' }}>
                        <h3 className="font-semibold text-gray-800 mb-3">
                            Return Departure Time
                        </h3>

                        <div className="grid grid-cols-2 sm:grid-cols-4">
                            {departTimesInbound.map((item) => (
                                <label
                                    key={item.id}
                                    className={`flex flex-col items-center p-1 border rounded-lg cursor-pointer transition-all duration-200 ${_props.selectedDepartureInbound.includes(item.time) ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-gray-400"}`}
                                >
                                    <input
                                        type="checkbox"
                                        value={item.time}
                                        id={item.id}
                                        onChange={_props.handleChangeDepartureInbound}
                                        className="hidden"
                                    />
                                    <div className="text-md mb-2">{item.icon}</div>
                                    <div className="font-semibold text-sm text-gray-700">{item.label}</div>
                                    <div className="text-xs text-gray-500">{item.timelabel}</div>
                                </label>
                            ))}
                        </div>
                        <h3 className="font-semibold text-gray-800 mb-3">
                            Return Arrival Time
                        </h3>
                        <div className="grid grid-cols-2 sm:grid-cols-4">
                            {arrivalTimesInbound.map((item) => (
                                <label
                                    key={item.id}
                                    className={`flex flex-col items-center p-1 border rounded-lg cursor-pointer transition-all duration-200 ${_props.selectedArrivalInbound.includes(item.time) ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-gray-400"}`}
                                >
                                    <input
                                        type="checkbox"
                                        value={item.time}
                                        id={item.id}
                                        onChange={_props.handleChangeArrivalInbound}
                                        className="hidden"
                                    />
                                    <div className="text-md mb-2">{item.icon}</div>
                                    <div className="font-semibold text-sm text-gray-700">{item.label}</div>
                                    <div className="text-xs text-gray-500">{item.timelabel}</div>
                                </label>
                            ))}
                        </div>
                    </div>
                </>
            }

        </aside>
    )
}

export default Filters
